import { ReactElement, useCallback, useEffect, useState } from "react";
import LoadingSpinner from "../shared/LoadingSpinner";
import { article } from "./ArticleInterfaces";
import { getArticleList } from "../../services/ArticleServices";
import ArticlesPreview from "./ArticlesPreview";
import { Grid2 as Grid } from "@mui/material";
import NewArticleModal from "./NewArticleModal";

const ActiveArticles = (): ReactElement => {
    const [articleData, setArticleData] = useState<article[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = useCallback(() => {
        getArticleList(setArticleData);
        setTimeout(() => { setIsLoading(false); }, 500)
    }, [setArticleData]);

    useEffect(() => {
        getData();
    }, [getData]);

    return <>
        {isLoading && <LoadingSpinner />}
        {
            <>
                <Grid container>
                    <Grid size={10} />
                    <Grid size={2}>
                        <NewArticleModal getData={getData} />
                    </Grid>
                </Grid>
                <p />
                <ArticlesPreview data={articleData} getData={getData} />
            </>
        }
    </>
}

export default ActiveArticles;